var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.component,{tag:"component",attrs:{"value":_vm.valueText}},[(_vm.isLink)?_c('a',{attrs:{"href":_vm.value,"target":"_blank"}},[_vm._v(_vm._s(_vm.value))]):_c('span',[_vm._v(_vm._s(_vm.valueText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }